import { DataLayer } from '@dgx-pr-spa/shared/util';

export class GAModalLanding {
  get gaData(): DataLayer {
    const dataLayer: DataLayer = {
      event: 'PRGenericGAEvent',
      eventPR: 'popupLandiingViewed',
      eventCategory: 'Product Replacement',
      eventAction: 'landing-pop-up',
      eventLabel: 'pop-up-viewed',
    };

    return dataLayer;
  }
}

export class GAModalNavigate {
  constructor(private slideNo: number) {}

  get gaData(): DataLayer {
    const dataLayer: DataLayer = {
      event: 'PRGenericGAEvent',
      eventPR: 'popupLandiingViewed',
      eventCategory: 'Product Replacement',
      eventAction: 'landing-pop-up',
      eventLabel: `pop-up-next-${this.slideNo + 1}`,
    };

    return dataLayer;
  }
}

export class GAModalClose {
  constructor(private type: string) {}

  get gaData(): DataLayer {
    const dataLayer: DataLayer = {
      event: 'PRGenericGAEvent',
      eventPR: 'popupLandiingViewed',
      eventCategory: 'Product Replacement',
      eventAction: 'landing-pop-up',
      eventLabel: `pop-up-${this.type}`,
    };

    return dataLayer;
  }
}
